import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { TaskObject } from 'src/app/models/tasks/tasks-table/task-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';

@Injectable({
    providedIn: 'root'
})
export class TaskConverter implements Converter<TaskObject> {

    constructor() { }

    convert(input: any): TaskObject {
        if (isNullOrUndefined(input)) {
            return TaskObject.create();
        }

        return new TaskObject(input.idTask, new Date(input.fechaError), new Date(input.fechaInicio), StringUtils.default(input.domain),
            StringUtils.default(input.operation), StringUtils.default(input.billingId), StringUtils.NOT_AVALIABLE,
            StringUtils.default(input.bussinessCrmId), StringUtils.default(input.taskType), StringUtils.default(input.errorCode),
            StringUtils.default(input.errorDescription), StringUtils.default(input.idProceso), StringUtils.default(input.actualOwnerId),StringUtils.default(input.queue));
    }
}
